import React, { useCallback } from 'react';
import { Menu, Dropdown, Avatar } from 'antd';
import { LogoutOutlined, ProfileOutlined } from '@ant-design/icons';
import Icon from '../util-components/Icon/index';

import { getUser } from 'api/login';
import { useQuery } from 'react-query';
import { Link, useHistory } from 'react-router-dom';
import logout from 'modules/authentication/actions/logout';
import { useDispatch } from 'react-redux';

const menuItem = [
  {
    title: 'Profile',
    icon: ProfileOutlined,
    path: '/dashboard/profile',
  },
];

export const NavProfile = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const onLogout = useCallback(
    e => {
      e.preventDefault();

      dispatch(logout());
      history.push('/');
    },
    [dispatch, history],
  );

  const resolver = useCallback(async (key, _eventId) => {
    const { body } = await getUser();

    return body?.data?.user || null;
  }, []);

  const { data } = useQuery('get-user', resolver);

  const profileMenu = (
    <div className="nav-profile nav-dropdown">
      <div className="nav-profile-header">
        <div className="d-flex">
          <Avatar size={45} src={data?.avatar_url} />
          <div className="pl-3">
            <h4 className="mb-0">{`${data?.first_name} ${data?.last_name}`}</h4>
            <span className="text-muted">{data?.role}</span>
          </div>
        </div>
      </div>
      <div className="nav-profile-body">
        <Menu>
          {menuItem.map((el, i) => {
            return (
              <Menu.Item key={i}>
                <Link to={el.path}>
                  <Icon className="mr-3" type={el.icon} />
                  <span className="font-weight-normal">{el.title}</span>
                </Link>
              </Menu.Item>
            );
          })}
          <Menu.Item key={menuItem.legth + 1}>
            <Link to={'/'} onClick={onLogout}>
              <LogoutOutlined className="mr-3" />
              <span className="font-weight-normal">Cerrar Sesión</span>
            </Link>
          </Menu.Item>
        </Menu>
      </div>
    </div>
  );
  return (
    <Dropdown placement="bottomRight" overlay={profileMenu} trigger={['click']}>
      <Menu className="d-flex align-item-center" mode="horizontal">
        <Menu.Item>
          <Avatar src={data?.avatar_url} />
        </Menu.Item>
      </Menu>
    </Dropdown>
  );
};

export default NavProfile;
